import React from "react";
import { faExclamationCircle, faInfoCircle, faWarning } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import "./Note.scss";

type Variant = "info" | "warning" | "error";

interface IProps {
    id: string;
    variant: Variant;
    title?: React.ReactNode;
    description?: React.ReactNode;
    replaceIcon?: React.ReactNode;
    children?: React.ReactNode;
    allign?: boolean;
}

export default function Note(props: IProps) {
    let icon = faInfoCircle;
    if (props.variant === "warning") icon = faWarning;
    else if (props.variant === "error") icon = faExclamationCircle;

    return (
        <div
            id={props.id + "-note"}
            className={`userful-note ${"userful-" + props.variant + "-note"} noselect`}
            style={{
                alignItems: props.allign ? "center" : "flex-start",
                height: props.allign ? 36 : "",
                width: props.allign ? "fit-content" : "100%",
            }}
        >
            <div className="userful-note-icon-wrapper">
                {!props.replaceIcon && <FontAwesomeIcon icon={icon} />}
                {props.replaceIcon && props.replaceIcon}
            </div>
            <div className="userful-note-container">
                <div className="userful-note-text">
                    {props.title && <h1>{props.title}</h1>}
                    {props.description && <p>{props.description}</p>}
                </div>
                {props.children && <div className="userful-note-sub-container">{props.children}</div>}
            </div>
        </div>
    );
}
